import React, { Suspense } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import {
  rowFormatter,
  countryColumns,
  prepareFilter,
  filterFields,
  filterInitialValues,
} from './BuildingReportUtils';


const CountryBuildingReportPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.countryBuildingReports }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url === "/blockReportCountry")) {
    const temp = menuList.find(q => q.url === "/blockReportCountry")
    isFullAccess = temp.isFullAccess;
  }


  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>

          <ContentRoute
            path="/blockReportCountry"
            render={props =>
              <ObjectsPage
                rowFormatter={rowFormatter}
                filterByShowButton={true}
                AuditAction={false}
                haveGeneralAction={false}
                isFullAccess={isFullAccess}
                basePath="/blockReportCountry"
                api="api/Place"
                getFunctionName="GetCountryReport"
                exportfuncName="GetExcelCountryReport"
                currentState={currentState}
                columns={countryColumns}
                prepareFilter={prepareFilter}
                filterFields={filterFields}
                filterInitialValues={filterInitialValues}
                enablePagination={false}
                haveExportButton={true}
                haveStimulsoftReport={true}
                mrtUrl="/reports/CountryBlockReports.mrt"
                jsonFileName="GetPlacesReport"
              />
            }
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default CountryBuildingReportPage



